import { ALL_PRODUCT_TYPES } from "../../constants";

export const getProductIcon = (label: string): JSX.Element | undefined => {
  const productType = Object.values(ALL_PRODUCT_TYPES).find(
    (type) => type.label === label
  );
  return productType ? productType.icon : undefined;
};
